// extracted by mini-css-extract-plugin
export var temperature = "ForecastTemperature-module--temperature--hUrQM";
export var animateIn = "ForecastTemperature-module--animateIn--xwxHZ";
export var unitDot = "ForecastTemperature-module--unitDot--1M6N6";